export default __webpack_public_path__ + "static/media/navBannerImg2.8417152e.png";